export default clientId => 'encodedVerifier-' + encodeURIComponent(clientId)
